import React from 'react'
import Helmet from 'react-helmet'
import Page from '../components/Page'
import PageHeader from '../components/PageHeader'
import Form from '../components/Form'
import { Container, Section } from '../components/common'
import Content from '../components/Content'

export default ({ title, data }) => {
  return (
    <Page>
      <PageHeader title={title} image={data.image} />
      <Section>
        <Container>
          <Form />
          {data.sidebar && <Content source={data.sidebar} />}
        </Container>
      </Section>
      <Helmet>
        <title>{title}</title>
      </Helmet>
    </Page>
  )
}



// WEBPACK FOOTER //
// ./src/views/Contact.js